// WATER RIGHT POSITION
export const GET_WR_POSITIONS = '/position/query';
export const GET_WR_POSITION = '/position/';
export const POST_WR_POSITION = '/position/';
export const PUT_WR_POSITION = '/position/';
export const DELETE_WR_POSITION = '/position/';
export const CHECK_WR_POSITION_EXISTS = '/position/query';
